const getDefaults = (initAppForPageBIParams = {}) => ({
  msid: initAppForPageBIParams.metaSiteId,
  visitorId: initAppForPageBIParams.visitorId,
  pageId: initAppForPageBIParams.pageId
})

module.exports = getDefaults



// WEBPACK FOOTER //
// ./bi/getDefaults.js